// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 14 ? "bh-helper-instance" : chunkId) + "-legacy." + {"14":"cdc5aee4","53":"24a40f91","121":"0ff98464","314":"e3f62eb1","351":"280bafab","580":"1e0385a7","701":"3ef99f75","715":"674b4368","860":"b7cdcb95"}[chunkId] + ".js";
};